import { formatDate } from '@utils/formatter';

type ServiceCheckType = 'ServiceCheck' | 'Unstable' | 'Pre' | 'Stable' | 'Test';

interface ServiceCheckReturnType {
  serviceStatus: ServiceCheckType;
  noticeOpen: boolean;
  date: string;
  startedTime: string;
  expiredTime: string;
}

const useServiceCheck = (): ServiceCheckReturnType => {
  const current = new Date();
  const expired = new Date('2022.03.10 19:00');
  const date = formatDate(current.toString(), 'YYYY년 MM월 DD일');
  const startedTime = '오후 6시 30분';
  const expiredTime =
    new Date(expired)
      .toLocaleTimeString('ko-kr', {
        hour: '2-digit',
        minute: '2-digit'
      })
      .replace(':', '시 ') + '분';

  const isTestMode = window.location.host.includes('test.capa.ai');

  if (isTestMode) {
    return {
      serviceStatus: 'Test',
      noticeOpen: false,
      date: date,
      startedTime: startedTime,
      expiredTime: expiredTime.toString()
    };
  }

  return {
    serviceStatus: 'ServiceCheck',
    noticeOpen: current < expired,
    date: date,
    startedTime: startedTime,
    expiredTime: expiredTime.toString()
  };
};

export default useServiceCheck;
